import { DetailsPanelType, useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { RollForwardActivity } from "PFApp/components/rollforward/roll_forward_activity";
import { Stack } from "PFComponents/containers";
import { RollforwardReference } from "PFCore/types";

import css from "./roll_forward_cell.module.scss";

type RollforwardTargetsCellProps = {
  activities: RollforwardReference[];
  type: DetailsPanelType.Role | DetailsPanelType.Engagement;
  mode?: "button" | "link";
};

export const RollforwardCell = ({ activities, type, mode = "button" }: RollforwardTargetsCellProps) => {
  const { openDetailsPanel } = useDetailsPanelsActions();

  if (activities.length === 0) {
    return null;
  }

  return (
    <Stack gap="spacingXs" alignItems="start" className={css.root}>
      {activities.map((target) => {
        const handleClick = () => {
          openDetailsPanel({ id: target.id, type }, true);
        };

        return (
          <RollForwardActivity
            key={target.id}
            rollForwardReference={target}
            mode={mode}
            onClick={handleClick}
          />
        );
      })}
    </Stack>
  );
};
